<template>
  <div class="container flex" style="margin-bottom: 20px;">
    <div>
      <left></left>
    </div>
    <div class="testright flex1" style="margin-left: 15px;border: 1px solid silver;">

    	<div class="border" style="border: none;">
    		<div class="flex">
    			<span class="font18" style="font-weight: bold;">第{{activeIndex+1}}题
          <template v-if="examObj.questionStatus==1">
            【单项选择题】
          </template>
          <template v-if="examObj.questionStatus==2">
            【多项选择题】
          </template>
          <template v-if="examObj.questionStatus==3">
            【计算题】
          </template>
          <template v-if="examObj.questionStatus==4">
            【综合题】
          </template>
          </span>
    			<span class="flex1"></span>
    			<span class="btns" v-if="activeIndex>0" @click="handlePrev()">
    				<img src="../assets/img/prev.png" >
    				<span class="font14">上一题</span>
    			</span>
    			<span class="btns" v-if="activeIndex!=list.length-1" @click="handleNext()">

    				<span class="font14">下一题</span>
    				<img src="../assets/img/next.png" style="margin-left: 5px;margin-right: 0;" >
    			</span>
    			<span class="btns" @click="handleAsk()">
    				<img src="../assets/img/doubt.png" >
    				<span class="font14">试题答疑</span>
    			</span>
    			<!-- <span class="btns" :class="{'active':examObj.collTag}" @click="handleCollect(examObj.collTag)">
    				<img src="../assets/img/collected.png" v-if="examObj.collTag" >
            <img src="../assets/img/remark.png" v-else >
    				<span class="font14">收藏</span>
    			</span> -->
    		</div>
    		<div class="line">

    		</div>
    		<div class="" style="padding: 20px 30px;" v-if="examObj.questionStatus==1">
    			<div class="flex">
    				<span class="flex1">{{examObj.questionTitle}}</span>

    			</div>
    			<div class="questionlist" v-for="item,index in examObj.optionList">
    				<span class="letters" :class="{'done':item.selected}" v-if="index==0">A</span>
            <span class="letters" :class="{'done':item.selected}" v-if="index==1">B</span>
            <span class="letters" :class="{'done':item.selected}" v-if="index==2">C</span>
            <span class="letters" :class="{'done':item.selected}" v-if="index==3">D</span>
            <span class="letters" :class="{'done':item.selected}" v-if="index==4">E</span>
            <span class="letters" :class="{'done':item.selected}" v-if="index==5">F</span>
            <span v-html="item.optionTitle"></span>
    			</div>


    		</div>
        <div class="" style="padding: 20px 30px;" v-if="examObj.questionStatus==2">
        	<div class="flex">
        		<span class="flex1">{{examObj.questionTitle}}</span>

        	</div>
        	<div class="questionlist" v-for="item,index in examObj.optionList">
        		<span class="letters" :class="{'done':item.selected}" v-if="index==0">A</span>
        	  <span class="letters" :class="{'done':item.selected}" v-if="index==1">B</span>
        	  <span class="letters" :class="{'done':item.selected}" v-if="index==2">C</span>
        	  <span class="letters" :class="{'done':item.selected}" v-if="index==3">D</span>
        	  <span class="letters" :class="{'done':item.selected}" v-if="index==4">E</span>
        	  <span class="letters" :class="{'done':item.selected}" v-if="index==5">F</span>
        	  <span v-html="item.optionTitle"></span>
        	</div>

        </div>
        <template  v-if="examObj.questionStatus==3 || examObj.questionStatus==4">
          <div class="zonghe" style="padding: 20px 30px;" v-html="examObj.questionTitle">
          </div>
          <div class="line">

          </div>
          <div class="" style="padding: 10px 30px;">
          	<div class="font14" style="color: #999;">
          		本大题共{{examObj.synthesizeList.length}}小题
          	</div>
          </div>
          <div class="" style="height: 319px;overflow-y: auto;">
          		<template v-for="item,index in examObj.synthesizeList">
          		  <div class="list" style="margin-top: 25px;">
          		  	<div class="quetsiontitle" v-html="(index+1)+'.'+item.questionTitle">

          		  	</div>
          		  	<template v-if="item.questionStatus== 3|| item.questionStatus==4">
          		  	  <textarea rows="" cols="" placeholder="请输入您的解答"></textarea>
          		  	</template>
                  <template v-if="item.questionStatus==1">
                    <div class="questionlist" v-for="voo,cindex in item.optionList">
                    	<span class="letters" :class="{'done':voo.selected}" v-if="cindex==0">A</span>
                      <span class="letters" :class="{'done':voo.selected}" v-if="cindex==1">B</span>
                      <span class="letters" :class="{'done':voo.selected}" v-if="cindex==2">C</span>
                      <span class="letters" :class="{'done':voo.selected}" v-if="cindex==3">D</span>
                      <span class="letters" :class="{'done':voo.selected}" v-if="cindex==4">E</span>
                      <span class="letters" :class="{'done':voo.selected}" v-if="cindex==5">F</span>
                      <span v-html="voo.optionTitle"></span>
                    </div>
                  </template>
                  <template v-if="item.questionStatus==2">
                    <div class="questionlist" v-for="voo,cindex in item.optionList">
                    	<span class="letters" :class="{'done':voo.selected}" v-if="cindex==0">A</span>
                      <span class="letters" :class="{'done':voo.selected}" v-if="cindex==1">B</span>
                      <span class="letters" :class="{'done':voo.selected}" v-if="cindex==2">C</span>
                      <span class="letters" :class="{'done':voo.selected}" v-if="cindex==3">D</span>
                      <span class="letters" :class="{'done':voo.selected}" v-if="cindex==4">E</span>
                      <span class="letters" :class="{'done':voo.selected}" v-if="cindex==5">F</span>
                      <span v-html="voo.optionTitle"></span>
                    </div>
                  </template>
                  <template v-if="examObj.answerStatus==1">
                   <div style="color: rgb(79, 167, 255); margin-top: 20px;">答案解析</div>
                   <div v-html="item.questionAnalysis" style="margin-top: 15px;"></div>
                  </template>
          		  </div>
          		</template>
          </div>
        </template>

    		<div class="line">

    		</div>
    		<div class="viewanswer" style="position: relative;padding: 0 30px;" v-if="examObj.answerStatus!=-1 && examObj.questionStatus<3">
    			<div style="color: #4fa7ff;margin-top: 20px;">答案解析</div>
    			<div class="" style="margin-top: 20px;margin-left: 15px;">
    				我的答案：<span style="font-weight: bold;">{{myAnswer?myAnswer:'未答'}}</span>
    			</div>
    			<div class="" style="margin-top: 20px;margin-left: 15px;">
    				参考答案：<span style="color: #5cb85c;">{{rightAnswer}}</span>
    			</div>
    			<div class="flex" style="margin-top: 20px;margin-left: 15px;">
    				<span style="width: 90px;">参考解析：</span><span style="font-size: 14px;color: #999999;" v-html="examObj.questionAnalysis"></span>
    			</div>
    			<img src="../assets/img/pcright.png" style="position: absolute;left: 200px;top: 20px;" v-if="examObj.answerStatus==1" >
          <img src="../assets/img/pcerror.png" style="position: absolute;left: 200px;top: 20px;" v-if="examObj.answerStatus==0" >
    		</div>
    	</div>
    </div>
  </div>
</template>

<script>
  import left from './left.vue'
  export default {
    name: 'Footer',
    components:{
      left
    },
    data () {
      return {
        list:[],
        data:'',
        examObj:{},
        childIndex:-1,//单选索引
        myAnswer:'',
        rightAnswer:'',
        moreList:[],
        activeIndex:-1
      }
    },
    methods:{
      handleAsk(){
        this.$router.push('submitquestion')
      },
      handlePrev(){
        this.activeIndex--;
      },
      handleNext(){
        this.activeIndex++;
      },
      getData(){

        this.$axios.get(this.$common.answerAnalysis_url).then((res)=>{
              if(res.data.code==1){
                  this.list=JSON.parse(res.data.data.content);
                  this.activeIndex=0
              }
              else {
                alert(res.data.msg)
              }
        })
      },
      getAnswer(){  //获取答案
        var lettersList=['A','B','C','D','E','F'];
        var myAnswer=[];
        var rightAnswer=[];
        this.examObj.optionList.forEach((item,index)=>{

            if(item.selected){

              myAnswer.push(lettersList[index])
            }
            if(item.optionAnswerStatus){

              rightAnswer.push(lettersList[index])
            }
        })

        this.myAnswer=myAnswer.join();
        this.rightAnswer=rightAnswer.join();
      },
    },
    created(){
      this.getData()
    },
    watch:{
      activeIndex(val){
        this.examObj=this.list[val];
        // console.log(this.examObj)
        // this.childIndex=-1;
        // this.moreList=this.examObj.optionList.map(()=>{
        //   return false
        // })
        // console.log(this.moreList)
        this.getAnswer();
      }
    }
  }
</script>

<style scoped>
  .btnlist {
  	display: flex;
    margin-bottom: 20px;
    border: 1px solid #f8f8f8;
    margin: -1px;
    border-bottom: 1px solid silver;
    padding-bottom: 15px;
  }
  .btnlist .btn {
  	font-size: 14px;
  	width: 120px;
  	height: 40px;
  	text-align: center;
  	background-color: #fff;
  	border: 1px solid silver;
  	line-height: 40px;
  	margin-right: 15px;
    color: #333;
    cursor: pointer;
  }
  .btnlist .active {
  	background-color: #4fa7ff;
  	border-color: #4fa7ff;
  	color: #fff;
  }
  .border {
  	padding: 20px;
  	border: 1px solid silver;
  }
  .questionlist {
  	margin-top: 20px;
  }
  .letters {
  	width: 30px;
  	height: 30px;
  	border: 1px solid #999999;
  	display: inline-block;
  	text-align: center;
  	line-height: 30px;
  	margin-right: 15px;
  	border-radius: 4px;
    cursor: pointer;
  }
  .done {
      border-color: #4fa7ff;
  }
  .viewanswer .btn {
  	width: 130px;
  	height: 50px;
  	line-height: 50px;
  	text-align: center;
  	color: #fff;
  	background-color: #4fa7ff;
  	display: inline-block;
  	margin-top: 15px;
    cursor: pointer;
  }
  .line {
  	height: 1px;
  	background-color: #eee;
  	margin: 15px -20px;
  }
  .btns {
  	padding: 4px 8px;
  	border: 1px solid silver;
  	display: flex;
  	align-items: center;
  	margin-left: 15px;
    cursor: pointer;
  }
  .btns.active {

        background-color: #4fa7ff;
        border-color: #4fa7ff;
  }
  .btns.active span {
    color: #FFFFFF !important;
  }
  .btns img {
  	margin-right: 5px;
  }
  textarea {
  	height: 180px;
  	width: 90%;
  	border: none;
  	background-color: #f5f5f5;
  	margin: 15px 0;
  	padding: 15px;
  	outline: none;
  	border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/analysis.vue